import type { AxiosResponse } from "axios";
import { BASE_URL, httpClient } from "../config/develop-config";

const baseUrl = `${BASE_URL}/crm/tier-program`;

const getTierProgramSettingList = async (params: { company: string }) => {
  return await httpClient
    .get(`${baseUrl}/get-tier-program-setting-list`, { params })
    .then((res: AxiosResponse) => res.data)
    .catch((err) => console.log(err));
};

const getTierAvailableYear = async (params: { company: string }) => {
  return await httpClient
    .get(`${baseUrl}/available-years`, { params })
    .then((res: AxiosResponse) => res.data)
    .catch((err) => console.log(err));
};

const getTierProgramTierLevel = async (programId: string) => {
  return await httpClient
    .get(`${baseUrl}/get-tier-level-list/${programId}`)
    .then((res: AxiosResponse) => res.data)
    .catch((err) => console.log(err));
};

const getTierProgramDetail = async (programId: string) => {
  return await httpClient
    .get(`${baseUrl}/get-tier-program-detail/${programId}`)
    .then((res: AxiosResponse) => res.data)
    .catch((err) => console.log(err));
};

const toggleRebatePercent = async (tierLevelId: string, isShowRebatePercent : boolean, updatedBy: string) => {
  return await httpClient
    .post(`${baseUrl}/toggle-rebate-percent`, { tierLevelId, isShowRebatePercent, updatedBy })
    .then((res: AxiosResponse) => res.data)
    .catch((err) => console.log(err));
};

export { getTierProgramSettingList, getTierProgramDetail, getTierProgramTierLevel, toggleRebatePercent, getTierAvailableYear };
